<template>
  <div class="page_container companyListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manageCenterIndex/userManagement' }">业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>加入企业or团队</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operation_wrap">
      <div class="flex-rowc filter_wrap">
        <div class="search_wrap flex-between">
          <el-input
            v-model="params.qyguid"
            placeholder="请输入企业成员邀请码→"
            @keyup.enter.native="handleSearch()"
          ></el-input>
          <div class="search_btn flex-rowc" @click="handleSearch">
            <i class="iconfont icon-chazhaotubiao"></i>
          </div>
        </div>
        <!-- <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示库存列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div> -->
      </div>
      <div class="txt">
        <p>STEP-01 请输入“企业成员邀请码”点击查找图标；</p>
        <p>STEP-02 根据检索查找结果，点击企业进入详情页后申请加入；</p>
      </div>
    </div>
    <div class="main_container">
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between"  @click="handleGo(item.id)">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="baseUrl + item.logo" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      <span>{{ item.qyname }}</span>
                    </p>
                    <p>
                      <span>{{ item.qyename }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p class="label_item" v-if="item.label1_name">
                      <span>{{ item.label1_name }}</span>
                    </p>
                    <p class="label_item" v-if="item.label2_name">
                      <span>{{ item.label2_name }}</span>
                    </p>
                    <p class="label_item" v-if="item.label3_name">
                      <span>{{ item.label3_name }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      所在地区：<span
                        >{{ item.provincename }} {{ item.cityname }}
                        {{ item.areaname }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn">详情→</div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无企业or团队"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>
<script>
import {encryptstringadd} from '../../api/api'
import { getCompanyList } from "../../api/company";
import storage from "../../utils/storage";
import { mapState } from "vuex";
export default {
  name: "companyList",
  props: {
    keyword: String,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      params: {
        Page: 1,
        PageSize: 10,
        qyguid: "",
        openid: storage.get("OPENID"),
      },
      listTotal: 0,
      dataList: [],
      loading: false,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    // this.initData();
  },
  methods: {
    initData() {
      let { params } = this;
      this.loading = true; //防止第一页重复加载
      getCompanyList(params).then((res) => {
        this.listTotal = res.total;
        this.dataList = res.list;
        this.loading = false;
      });
    },
    handleCurrentChange(e) {
      this.params.Page = e;
      this.initData();
    },

    handleSearch() {
      let { params } = this;
      if (params.qyguid == "") {
        this.listTotal = 0;
        this.dataList = [];
        return;
      } else {
        this.initData();
      }
    },
    handleGo(id) {
      this.encryptstringadd("companyDetail", {qyid: id });
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.companyListPage {
  .item_main_wrap {
    cursor: pointer;
    .pic_box {
      width: 100px;
      height: 100px;
    }
  }
  .main_container {
    .list_wrap {
      height: 48vh;
      .link {
        font-size: 16px;
        cursor: pointer;
        margin-top: 40px;
        &:hover {
          color: blue;
        }
      }
    }
  }
  .operation_wrap {
    width: 550px;
    margin: 30px auto 20px;
    height: auto;
    // position: absolute;
    // left: 50%;
    // margin-top: 20px;
    // transform: translateX(-50%);
    .filter_wrap {
      margin-bottom: 10px;
    }
    .search_wrap {
      border: 1px solid #dcdfe6;
      border-radius: 44px;
      flex: 1;
      // margin-bottom: 10px;
      /deep/ .el-input__inner {
        border: none;
        border-radius: 45px;
      }
      .search_btn {
        width: 50px;
        cursor: pointer;
      }
    }
    .txt {
      color: red;
      font-size: 12px;
      p {
        margin-bottom: 5px;
      }
    }
  }
}
</style>